export enum CashoutOperationStatus {
  INITIATED = 'Initiated',
  PAYMENT_CREATED = 'PaymentCreated',
  COMPLETED = 'Completed',
  ERROR = 'Error',
  EXPIRED = 'Expired',
}

export interface CashoutOperation {
  id: number;
  regDate: string;
  expirationDate: string;
  payDate: string | null;
  cashoutCode: string;
  cashoutStatus: CashoutOperationStatus;
  merchantCode: string;
  merchantName: string;
  saleAreaId: number;
  amountMdl: number;
  email: string;
  logoCode: string;
  successUrl: string;
  cancelUrl: string;
  description: string;
}

export interface ResendEmail {
  operationId: number;
  email: string;
}

export interface CashoutOperationError {
  resultCode: string;
  resultMessage: string;
}
